import { render } from "./Avatar_userList.vue?vue&type=template&id=7daa5660"
import script from "./Avatar_userList.vue?vue&type=script&lang=js"
export * from "./Avatar_userList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__